/*
 * @Author: LCQ
 * @Date: 2024-05-15 17:15:43
 * @LastEditTime: 2024-05-20 18:03:37
 * @LastEditors: LCQ
 * @Description: 车辆上牌
 * @FilePath: \operation.dstcar.com\src\router\carRegistration\index.js
 */
export default [
  {
    path: '/carRegistration/list',
    name: 'CarRegistrationList',
    component: () => import('@/pages/carRegistration/list'),
    meta: {
      // storeKey: 'oss:aftersales:app:plate:workorder'
      storeKey: '*'
    }
  },
  {
    path: '/carRegistration/findOrder',
    name: 'CarRegistrationFindOrder',
    component: () => import('@/pages/carRegistration/findOrder'),
    meta: {
      storeKey: '*'
    }
  },
  {
    path: '/carRegistration/registration',
    name: 'CarRegistrationRegistration',
    component: () => import('@/pages/carRegistration/registration'),
    meta: {
      storeKey: '*'
    }
  }
]



// WEBPACK FOOTER //
// ./src/router/carRegistration/index.js